import { render, staticRenderFns } from "./MyJobs.vue?vue&type=template&id=90fc22b8&scoped=true&"
import script from "./MyJobs.vue?vue&type=script&lang=js&"
export * from "./MyJobs.vue?vue&type=script&lang=js&"
import style0 from "./MyJobs.vue?vue&type=style&index=0&id=90fc22b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fc22b8",
  null
  
)

export default component.exports